// extracted by mini-css-extract-plugin
export default {"icon":"common-components-FlagIcon-FlagIcon__icon--myL15"};